/**
 * COLORDS — sepet çekmecesinde kupon uygulama.
 *
 * Shopify Cart AJAX API'sinde indirim kodu uygulama uç noktası yoktur.
 * Desteklenen tek yol `/discount/{KOD}` isteğidir: kod oturuma işlenir.
 * Ardından sepet bölümleri Section Rendering API ile tazelenir ve
 * cart-drawer.renderContents() ile çekmece yeniden çizilir.
 */
(() => {
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  const getCart = () =>
    document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const indirimSayisi = async () => {
    try {
      const c = await (await fetch('/cart.js', { cache: 'no-store' })).json();
      return (c.discount_applications || []).length;
    } catch (e) {
      return 0;
    }
  };

  const mesaj = (kok, metin, hataMi) => {
    const el = kok.querySelector('[data-cdisc-msg]');
    if (!el) return;
    el.textContent = metin;
    el.hidden = false;
    el.classList.toggle('is-error', Boolean(hataMi));
  };

  /** Sepet bölümlerini yeniden çizer (ürün eklemeden). */
  const sepetiTazele = async () => {
    const cart = getCart();
    const url = `${window.location.pathname}?sections=${SECTIONS.join(',')}`;
    const sections = await (await fetch(url, { cache: 'no-store' })).json();
    if (cart && typeof cart.renderContents === 'function') {
      cart.renderContents({ sections });
    }
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-cdisc-form]');
    if (!form) return;
    event.preventDefault();

    const kok = form.closest('[data-cdisc]');
    const input = form.querySelector('[data-cdisc-input]');
    const btn = form.querySelector('[data-cdisc-submit]');
    const kod = (input.value || '').trim();

    if (!kod) {
      mesaj(kok, 'Lütfen bir kupon kodu girin.', true);
      input.focus();
      return;
    }

    btn.disabled = true;
    btn.dataset.loading = 'true';

    const oncekiAdet = await indirimSayisi();

    try {
      // Kodu oturuma işle
      await fetch(`/discount/${encodeURIComponent(kod)}`, { cache: 'no-store' });

      const sonrakiAdet = await indirimSayisi();

      if (sonrakiAdet > oncekiAdet) {
        input.value = '';
        await sepetiTazele();
        // renderContents çekmeceyi yeniden bastığı için mesajı yeni DOM'a yazıyoruz
        const yeniKok = document.querySelector('[data-cdisc]');
        if (yeniKok) mesaj(yeniKok, 'Kupon uygulandı.', false);
      } else {
        mesaj(kok, 'Bu kupon geçerli değil ya da sepetinize uygulanamıyor.', true);
      }
    } catch (e) {
      mesaj(kok, 'Kupon uygulanamadı. Lütfen tekrar deneyin.', true);
    } finally {
      btn.disabled = false;
      delete btn.dataset.loading;
    }
  });
})();
